import { Link } from "gatsby";
import React, { useState } from "react";
import CTALink from "./CTALink";
import { getFluidGatsbyImage } from "gatsby-source-sanity";
import clientConfig from "../../client-config";

const NavMobileButton = props => {
  // const [showMobileNav, toggleMobileNav] = useState(false);

  // let navButtonClass = "absolute top-0 right-0 mt-4 mr-5 block h-auto lg:hidden transform scale-150";
  // let navButtonBar = "block mt-1 h-1 w-6 bg-secondary rounded transition duration-200 ease-in-out"
  // let navButtonCross = `${navButtonBar} bg-cta origin-left transform`
  // let navButtonCenter = `${navButtonBar} bg-cta origin-center transform scale-x-0`

  // return (
  //   <div className={navButtonClass} onClick={() => toggleMobileNav(!isOpen)}>
  //     <span className={showMobileNav ? `${navButtonCross} rotate-45` : navButtonBar}></span>
  //     <span className={showMobileNav ? navButtonCenter : navButtonBar}></span>
  //     <span className={showMobileNav ? `${navButtonCross} -rotate-45` : navButtonBar}></span>
  //   </div>
  // );
}

const Header = ({ showNav, siteTitle, scrolled, siteLogo, navMenuItems = [], textWhite = true }) => {
  const [showMobileNav, toggleMobileNav] = useState(false);

  let headerClass = "fixed w-full sticky z-30 top-0 text-secondary bg-primary transition-all duration-200 ease-in-out border-primary border-b-2";
  headerClass += scrolled ? " shadow" : "";

  let navActionClass =
    "mx-auto lg:mx-0 hover:underline font-bold rounded-full mt-4 lg:mt-0 py-4 px-8 shadow opacity-75 bg-secondary";
  // navActionClass += !textWhite || !scrolled ? "bg-secondary text-darker" : "";
  // navActionClass += textWhite || scrolled ? " gradient text-secondary" : "";
  let navContentClass =
    "relative w-full text-center flex-grow align-items-center lg:flex lg:items-center lg:w-auto lg:block mt-2 lg:mt-0 text-black p-2 lg:p-0 z-20";
  navContentClass += " overflow-hidden transition-all duration-200 ease-in-out transform origin-center";
  // navContentClass += !textWhite || !scrolled ? " lg:bg-transparent bg-gray-100" : "";
  // navContentClass += textWhite || scrolled ? " bg-primary" : "";
  navContentClass += showMobileNav ? "" : " hidden";

  let titleClass = "toggleColour no-underline hover:no-underline font-display font-bold text-2xl lg:text-4xl opacity-0 transition-all duration-200 ease-in-out text-secondary opacity-100";
  // titleClass += !textWhite || scrolled ? " text-secondary opacity-100" : "";
  // titleClass += textWhite || !scrolled ? " text-secondary" : "";

  const logo = null;
  if (siteLogo && siteLogo.image && siteLogo.image.asset && !siteLogo.disabled) {
    const fluidProps = getFluidGatsbyImage(
        siteLogo.image.asset._id,
        { maxWidth: 960 },
        clientConfig.sanity
      );
    logo = <img src={fluidProps.src} alt={siteLogo.image.alt} />;
    console.log(siteLogo);
  }

  let navButtonClass = "absolute top-0 right-0 mt-3 mr-4 block h-auto lg:hidden transform scale-150";
  let navButtonBar = "block mt-1 h-1 w-6 bg-secondary rounded transition duration-200 ease-in-out"
  let navButtonCross = `${navButtonBar} bg-cta origin-left transform`
  let navButtonCenter = `${navButtonBar} bg-cta origin-center transform scale-x-0`

  return (
    <nav id="header" className={headerClass} style={{backdropFilter: "blur(4px)"}}>
      <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-2">
        <div className="pl-4 flex items-center">
          {logo}
          <Link id="siteTitle" className={titleClass} to="/">
            {" "}
            {siteTitle}
          </Link>
        </div>

        {showNav && navMenuItems && (
          <div className={navContentClass} id="nav-content">
            <ul className="list-reset lg:flex justify-end flex-1 items-center">
              {navMenuItems.map((i) => (
                <li className="mr-3 text-secondary font-bold p-5 lg:p-0 hover:underline">
                  <CTALink {...i} buttonActionClass={navActionClass} />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className={navButtonClass} onClick={() => toggleMobileNav(!showMobileNav)}>
        <span className={showMobileNav ? `${navButtonCross} rotate-45` : navButtonBar}></span>
        <span className={showMobileNav ? navButtonCenter : navButtonBar}></span>
        <span className={showMobileNav ? `${navButtonCross} -rotate-45` : navButtonBar}></span>
      </div>
    </nav>
  );
};

export default Header;
